import React from "react";
import { CajaRow3 } from "../../../../../components/cajaRow3/CajaRow3";

export const ServiciosItem = ({ servicio }) => {
  const { servicio: nombre, cantidad, monto } = servicio;
  return <CajaRow3 nombre={nombre} cantidad={cantidad} monto={monto} />;
};
